export const DEFAULT_PORTAL_METRICS = [
  { key: "ISO_4um", label: "ISO >4 µm", unit: "", warning: null, critical: null, primary: true, kind: "number", group: "iso" },
  { key: "ISO_6um", label: "ISO >6 µm", unit: "", warning: null, critical: null, primary: false, kind: "number", group: "iso" },
  { key: "ISO_14um", label: "ISO >14 µm", unit: "", warning: null, critical: null, primary: false, kind: "number", group: "iso" },
  { key: "cs_temperature_c", label: "CS-temperatuur", unit: "°C", warning: 60, critical: 75, primary: false, kind: "number", group: "sensor" },
  { key: "low_saturation_pct_rh", label: "Vochtverzadiging", unit: "% RH", warning: 60, critical: 80, primary: false, kind: "number", group: "sensor" },
  { key: "temperature_c", label: "HLB-temperatuur", unit: "°C", warning: 60, critical: 75, primary: false, kind: "number", group: "sensor" },
  { key: "conductivity_ns_m", label: "Geleidbaarheid", unit: "nS/m", warning: null, critical: null, primary: false, kind: "number", group: "sensor" },
  { key: "change_conductivity_pct", label: "Verandering geleidbaarheid", unit: "%", warning: null, critical: null, primary: false, kind: "number", group: "sensor" },
  { key: "relative_permittivity", label: "Relatieve permittiviteit", unit: "", warning: null, critical: null, primary: false, kind: "number", group: "sensor" },
];

const LEGACY_KEYS = {
  temperature: "temperature_c",
  voltage_v: "relative_permittivity",
};

const METRIC_BY_KEY = Object.fromEntries(DEFAULT_PORTAL_METRICS.map((metric) => [metric.key, metric]));
const CS_KEYS = ["ISO_4um", "ISO_6um", "ISO_14um", "cs_temperature_c"];
const HLB_KEYS = ["low_saturation_pct_rh", "temperature_c", "conductivity_ns_m", "change_conductivity_pct", "relative_permittivity"];

export function completeMetricDefinitions(definitions = [], sensors = {}) {
  const normalized = [];
  const seen = new Set();

  for (const raw of Array.isArray(definitions) ? definitions : []) {
    if (!raw || typeof raw !== "object" || !raw.key) continue;
    const key = LEGACY_KEYS[raw.key] || raw.key;
    if (seen.has(key)) continue;
    const canonical = METRIC_BY_KEY[key];
    normalized.push(canonical ? { ...raw, ...canonical, key } : { ...raw, key });
    seen.add(key);
  }

  const requiredKeys = [];
  if (sensors?.cs1000_enabled !== false) requiredKeys.push(...CS_KEYS);
  if (sensors?.hlb1400_enabled !== false) requiredKeys.push(...HLB_KEYS);
  for (const key of requiredKeys) {
    if (!seen.has(key)) {
      normalized.push({ ...METRIC_BY_KEY[key] });
      seen.add(key);
    }
  }

  if (!normalized.some((metric) => metric.primary) && normalized.length) normalized[0].primary = true;
  return normalized;
}

export function normalizeMetricValues(values = {}) {
  const normalized = { ...(values || {}) };
  if (normalized.temperature_c == null && normalized.temperature != null) normalized.temperature_c = normalized.temperature;
  if (normalized.relative_permittivity == null && normalized.voltage_v != null) normalized.relative_permittivity = normalized.voltage_v;
  return normalized;
}

export function normalizeMetricSeries(series = []) {
  return (Array.isArray(series) ? series : []).map((row) => normalizeMetricValues(row));
}
